module.exports = __webpack_public_path__ + "img/label-mc-nb2.9e67db0e.png";